export class TechConfirmModel {
  title?: String;
  message?: String;
  cancelText?: String;
  confirmText?: string;
}
